
var sprite = require("/data/src/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 40 40\" id=\"phone-icon\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <path d=\"M20.03,30.29c-0.957,0-1.736,0.778-1.736,1.735c0,0.958,0.779,1.736,1.736,1.736s1.736-0.778,1.736-1.736\n\tC21.767,31.068,20.987,30.29,20.03,30.29z\"/> <path d=\"M28.618,2.967H11.442c-1.445,0-2.621,1.176-2.621,2.621v28.825c0,1.445,1.175,2.621,2.621,2.621h17.176\n\tc1.445,0,2.621-1.176,2.621-2.621V5.587C31.239,4.143,30.063,2.967,28.618,2.967z M11.442,4.714h17.176\n\tc0.481,0,0.874,0.392,0.874,0.874v21.595H10.569V5.587C10.569,5.105,10.96,4.714,11.442,4.714z M28.618,35.286H11.442\n\tc-0.482,0-0.874-0.392-0.874-0.874V29.08h18.923v5.332C29.492,34.895,29.1,35.286,28.618,35.286z\"/> </symbol>";
module.exports = sprite.add(image, "phone-icon");


//////////////////
// WEBPACK FOOTER
// ./src/icons/phone-icon.svg
// module id = 364
// module chunks = 36